const student = {

    // headings
    create: 'Create a new Student',
    edit: 'Edit Student',
    editAlumni: 'Edit Alumni',
    studentImport: 'Student Import',
    studentApplicationImport: 'Student Application Documents Import',
    documentType: 'Document Type',
    documentFileName: 'Document File Name',
    studentImportList: 'Student Import',

    graduationImport: 'Graduation Import',
    graduationImportList: 'Graduation Import List',
    gradeImport: 'Grade Import',
    gradeImportList: 'Grade Import List',

    statusImport: 'Status Import',
    statusImportList: 'Status Import List',
    statusImportPreview: 'Status Import Preview',
    statusImportColumns: 'Columns in this order: Student Number, Partner Code, Status, Notes, Status Date.',
    statusImportDateRule: 'Status Date may be empty – today’s date (Europe/Zurich) will then be used.',
    validRecords: '{count} valid record(s)',
    errorRecords: '{count} record(s) with errors – excluded from import',
    noRecordFound: 'No record found.',

    uploadFile: 'Drag or Upload file here:',
    courseEnrollment: 'Course Enrollment Report (Online MBA and Online MBA (new courses))',
    selectCourse: 'Select Course',
    courseCode: 'Course Code',
    courseTitle: 'Course Title',
    booksIncl: 'Books Incl.',
    confirmCopy: 'Are you sure you want to copy this student record? A new student number will be generated.',

    // List
    studentList: 'Student List',
    studentPreliminaryList: 'Preliminary Acceptance Student List',
    alumniList: 'Alumni List',
    preliminaryList: 'Preliminary Acceptance List',
    searchCriteria: 'Filter Preset',
    studentName: 'Student Name',
    alumniName: 'Alumni Name',
    numberFrom: 'Student Number From',
    numberTo: 'Student Number To',
    postalCode: 'Postal Code',
    select: '--Select--',
    yes: 'Yes',
    no: 'No',
    graduationYear: 'Graduation Year',
    graduationDate: 'Graduation Date',
    presetName: 'Enter Preset Name',
    examName: 'Exam Name',
    examScore: 'Exam Score',
    accept: 'Accept',
    reject: 'Reject',
    applicationDocument: 'Application Documents',

    // Tabs
    tabPersonal: 'Personal Information',
    tabBusiness: 'Business Information',
    tabRemarks: 'Remarks',
    tabAdmission: 'Admissions',
    tabProgram: 'Program',
    tabGrade: 'Grades',
    tabGraduation: 'Graduation Requirements',
    tabAttachment: 'Attachments',
    tabAbsence: 'Absences',
    tabApplication: 'Application',
    tabAudits: 'Audit Log',
    tabFinance: 'Finance',
    tabPaymentSummaries: 'Payment Summaries',
    tabTranscript: 'Transcripts',
    noGradingScale: 'No automatically grading scale found against <strong>{code} Program Code</strong>. Please add through <strong>Settings -> Registrar -> Grading Scale</strong> or contact <strong>Support Team<strong>.',

    // Personal Tab
    programStart: 'Program Start',
    byMonth: 'By Month',
    byYear: 'By Year',
    status: 'Status',
    statusHistory: 'Status History',
    studentStatusComment: 'Student Status Comment',
    studentStatusDate: 'Student Status Date',
    note: 'Please add a Note',
    linkedRecords: 'Linked Records',
    permitExpiryDate:'Permit Expiration Date',
    passportExpiryDate:'Passport Expiration Date',

    statusDate: 'Date',
    statusNote: 'Note',
    sisEnabled: 'SISEnabled',
    gradeNotifications: 'Grade Notifications',

    studentNumber: 'Student Number',
    title: 'Title',
    firstName: 'First Name',
    lastName: 'Last Name',
    transcriptName: 'Transcript Name',
    birthDate: 'Birth Date',
    dateOfBirth: 'Date of Birth',
    birthPlace: 'Birth Place',
    birthCountry: 'Birth Country',
    nationality: 'Nationality',
    streetAddress: 'Street Address',
    city: 'City',
    zip: 'Zip',
    country: 'Country',
    phone: 'Phone',
    mobile: 'Mobile',
    email: 'Email',
    email2: 'Email 2',
    email3: 'Email 3',
    notes: 'Notes',
    partnerCode: 'Partner Code',
    partnerCampus: 'Partner Campus',
    PartnerCampusLocation: 'Partner Campus',
    CampusLocation: 'Campus Location',
    matriculationNum: 'Matriculation Number',

    mailAddress: 'Mail Address',
    exportAddress: 'Export Address',
    mailAddressOption1: 'Personal Address',
    mailAddressOption2: 'Business Address',

    gradeNotify: 'Access & Notification Settings',
    gradeNotifyOption1: 'Enable Online Transcript',
    gradeNotifyOption2: 'Enable Grade Notifications',
    gradeNotifyOption3: 'Enable Birthday Notifications',

    legalization: 'Legalization',
    legalizationOption1: 'Legalization Required',

    // Business Tab
    companyName: 'Company Name',
    department: 'Department',
    position: 'Position',
    fax: 'Fax',
    webAddress: 'Web Address',
    contactPerson: 'Contact Person:',

    // Remarks Tab
    remarks: 'Remarks',
    remarksExportNote: 'Please update the student record first to export the latest remarks.',

    // Admission Tab
    background: 'Educational Background:',
    bachelorAdmission: 'Bachelor Admission:',
    masterAdmission: 'Master Admission:',
    doctorateAdmission: 'Doctorate Admission:',
    admissionOption1: 'Admissions Exam taken',
    admissionOption2: 'Entrance Exam taken',
    admissionOption3: 'Other',
    result: 'Result',

    // Program Tab
    program: 'Program',
    programCode: 'Program Code',
    NotEqualWithdrawnAndGraduated: 'student cant be graduated and withdrawn at the same time uncheck one of them',
    programType: 'Program Type',
    academicYear: 'Academic Year',
    program2: 'Secondary Major',
    books: 'Books Included',
    graduate: 'Graduated',
    withdrawn: 'Withdrawn',
    thesisSubject: 'Thesis Subject',
    defenceExaminer: 'Defense Examiners',
    graduateDate: 'Graduation Date',
    thesisPercentage: 'Thesis Percentage',
    thesisGrade: 'Thesis Grade',
    thesisMentor: 'Thesis Mentor',
    thesisEvaluation: 'Thesis Evaluation Form',
    addProfessor: 'Add new Professor',
    programCode2: 'Program Code 2',
    programTitle2: 'Program Title 2',
    programType2: 'Program Type 2',
    academicYear2: 'Academic Year 2',

    // Grades Tab
    courseSearch: 'Select course to add',
    course: 'Course',
    percentage: 'Percentage',
    grade: 'Grade',
    descGrade: 'Descriptive Grade',
    ectsGrade: 'ECTS Grade',
    finalExam: 'Final Exam',
    ectsCredits: 'ECTS Credits',
    sbsCredits: 'SBS Credits',
    enroll: 'Enrolled',
    action: 'Action',
    deductibleCredits:'Transfer Credit Deductible',
    primaryGrades: 'Primary Grades',
    secondaryGrades: 'Secondary Grades',
    foundationGrades: 'Foundation Program Grades',
    gpa: 'GPA:',
    fpGpa: 'FP GPA:',
    localGpa: 'Local GPA:',
    fpLocalGpa: 'FP Local GPA:',
    coursesCount: '{count} courses will be added to the student. Proceed?',
    gradeExists: 'Course Already assigned!',
    alreadyAssigned: 'Courses already assigned!',

    // Graduation Requirement Tab
    bachelorProgram: 'Bachelor Programs:',
    bachelorProgramOption1: 'Sent Exit Survey',
    bachelorProgramOption2: 'Bachelor Exit Exam (CBE) taken',

    masterProgram: 'Master Programs:',
    masterProgramOption1: 'Sent Exit Survey',
    masterProgramOption2: 'Master Exit Exam (SBS) Taken',
    masterProgramOption3: 'Master Exit Exam (Pregrine) Taken',
    masterProgramOption4: 'Internship Report submitted and passed',

    doctorateProgram: 'Doctorate Programs:',
    continuingEducation: 'Further Education:',
    doctorateProgramOption1: 'Sent Exit Survey',
    doctorateProgramOption2: 'Exit Exam (SBS) Taken',
    doctorateProgramOption3: 'Exit Exam (pregrine) Taken',

    allPrograms: 'All Programs:',
    allProgramsOption1: 'Passing GPA',
    allProgramsOption2: 'No financial obligations to SBS',

    programScore: 'Exam Scores',

    searchCourse: 'Search course to add...',
    dba: 'DBA:',
    ethicsApprovalDoc: 'Ethics Approval Doc:',
    approvedDate: 'A (approved) Date:',
    statisticsExamDate: 'Statistics Exam Date:',
    statisticsExamResult: 'Statistics Exam Result:',
    compsDate: 'COMPS Date:',
    compsResult: 'COMPS Result:',
    maIssued: 'MA Issued',
    mabrIssued: 'MABR Issued',
    maDate: 'MA Degree Conferral Date:',
    mabrDate: 'MABR Degree Conferral Date:',
    dissertation: 'Dissertation:',
    dissertationDate: 'Dissertation Oral Defense Date:',
    degreeIssued: 'DBA Degree Issued',
    degreeIssueDate: 'DBA Conferral Date:',
    degreeConferralDate: 'Degree conferral date:',

    // Attachment Tab
    file: 'File',
    fileName: 'Name',
    UploadTimestamp:'Upload Timestamp',
    fileDescription: 'Description',
    fileAttach: 'Attach File:',
    fileAttachDrop: 'Click or Drag a file(s) here to upload.',

    // Application Tab
    uploadFiles: 'Upload Files',
    sr: ' Item Nr.',
    reason: 'Document Description',
    checkMultiple: 'Check if Multiple',
    completeCurriculumVitae: 'Complete Curriculum Vitae, incl. current/previous professional experience',
    certifiedCopyHighSchool: 'Certified copy of high school degree',
    officialAcademicTranscripts: 'Official academic transcripts',
    motivationLetter: 'Motivation letter ca. one A4 page (accepted formats: PDF/Word)',
    aSatScore: 'A SAT score of minimum 1200 (if applicable)',
    englishProficiency: 'Proof of English proficiency (TOEFL, IELTS, or equivalent)',
    onePicture: 'One high-resolution picture (passport photo style) in .JPG, .PNG or .GIF',
    additionalDocument: 'Additional Documents',
    certifiedCopyBachelor: 'Certified copy of bachelor’s degree',
    twoReferenceLetters: 'Two reference letters (professional or academic)',
    certifiedCopyMaster: 'Certified copy of MBA/Master degree',
    employmentConfirmationLetter: 'Employment confirmation letter',
    researchInterestOutline: 'Area of Research Interest Outline',
    uploadedApplicationsFiles: 'Uploaded Applications Files',
    CV: 'CV',
    degree: 'Degree',
    transcript: 'Transcript',
    letter: 'Letter',
    picture: 'Picture',
    openInNewTab: 'Click to open in new tab.',
    remove: 'Click to Remove',
    passportCopy: 'Passport Copy/ID',
    permitCopy: 'Permit Copy',

    // Absences
    absenceDate: 'Absence Date',
    absenceReason: 'Absence Reason',
    absenceCourse: 'Course',
    absenceRemarks: 'Remarks',

    // Finance
    globalDiscount: 'Global Scholarship Reduction (in %)',
    FullPaymentDiscount: 'Full Payment Discount (in %)',
    reduction_type: 'Reduction Type',
    paymentPlan: 'Payment Plan',
    open: 'Open',
    all: 'All',
    paid: 'Paid',
    pending: 'Pending',

    // Payment Summaries
    createPaymentSummary: 'Create Payment Summary',
    paymentSummaries: 'Payment Summaries',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    summaryDate: 'Summary Date',
    currency: 'Currency',
    titleText: 'Title Text',
    introText: 'Introduction Text',
    closingText: 'Closing Text',
    drag: 'Drag',
    sort_order: 'Sort Order',
    amountReceived: 'Amount Received',
    invoiceNumber: 'Invoice Number',
    dateFeesReceived: 'Date Fees Received',
    totalPaymentReceived: 'Total Payment Received:',
    totalFees: 'Total fees paid to date:',
    id: 'ID',
    summaryNumber: 'Summary Number',
    date: 'Date',
    totalAmount: 'Total Amount',
    createPaymentSummary: 'Create New Payment Summary',
    savePaymentSummary: 'Save Payment Summary',
    groupByYear: 'Group by Year',
    customGrouping: 'Custom Grouping',
    unspecifiedGroup: 'Unspecified Group',
    group: 'Group',
    year: 'Year',
    groupNumber: 'Group Number',
    grandTotalLabel: 'Grand Total Label',
    totalFeesPaidToDate: 'Total fees paid to date:',
    subtotalLabels: 'Subtotal Labels',
    subtotalText: 'Subtotal Text',
    noYear: 'No Year',
    totalFeesPaid: 'Total fees paid:',
    totalFeesForYear: 'Total fees paid for the year {year}:',
    totalFeesForGroup: 'Total fees paid for group {group}:',

    // Transcript
    noTranscript: 'No transcript record.',

    preliminaryModalTitle: 'Preliminary Acceptance Approval',
    noRecord: 'No record found. If the student already graduated, please check the alumni records.',
    record: 'record',
    import: 'Import',
    associateDegree:'Associate degree or equivalent 120 ECTS',

    error:'Error'
};

export default student;